import { createContext, useContext } from "react";
import Cookies from "universal-cookie";

const CookiesContext = createContext(undefined);

export const CookiesProvider = ({children}) => {
    //FUNCTIONS
    const setCookie = (cname, cvalue) => {
        const cookies = new Cookies();
        let d = new Date();
        d.setTime(d.getTime() + (10 * 365 * 24 * 60 * 60 * 1000));
    
        cookies.set(cname, cvalue, {
            expires: d,
        });
    }

    const getCookie = (cname) => {
        const cookies =  new Cookies();
        return cookies.get(cname);
    }
    
    const deleteCookie = (cname) => {
       const cookies = new Cookies();
       cookies.remove(cname);
    }
    
    
    const value = {
        setCookie,
        getCookie,
        deleteCookie,
    }

    return (
        <CookiesContext.Provider value={value}>
            {children}
        </CookiesContext.Provider>
    )
}

export const useCookies = () => useContext(CookiesContext);
